import { Tbody, Tr, Td, Box } from '@chakra-ui/react';

const loaderStyle = {
  height: '24px',
  backgroundColor: '#E5E7EB',
  borderRadius: '4px',
  animation: 'pulse 1.5s ease-in-out infinite',
};

const NUMBER_OF_ROWS = 20;

const LoadingState = ({
  numberOfColumns,
  showSpacerColumn = false,
}: {
  numberOfColumns: number;
  showSpacerColumn?: boolean;
}) => {
  /* eslint-disable react/no-array-index-key */
  return (
    <Tbody>
      {Array.from({ length: NUMBER_OF_ROWS }).map((_, index) => (
        <Tr key={`loading-row-${index}`}>
          {Array.from({ length: numberOfColumns }).map((x, index2) => (
            <Td key={`loading-cell-${index2}`}>
              <Box sx={loaderStyle} />
            </Td>
          ))}
          {showSpacerColumn && <Td />}
        </Tr>
      ))}
    </Tbody>
  );
  /* eslint-enable */
};

export default LoadingState;
